import { useQuery } from '@tanstack/react-query';

import {
  EconomicalValueChannelSourceFilters,
  EconomicalValueChannelSourceType,
} from '@/features/broadcasters/types';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { economicalValueChannelSourcesQueryKeys } from './query-keys';

export async function getEconomicalValueChannelSourcesList(
  params?: ParamsWithPagination<EconomicalValueChannelSourceFilters>
): Promise<PaginatedResponse<EconomicalValueChannelSourceType>> {
  return mediaManagerClient.get('/api/v1/economical_value_channel_sources', {
    params: {
      deleted_at__isnull: true,
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
      order_by: params?.order_by,
      id__in: params?.idIn?.join(','),
      scope__in: params?.scopeIn,
      media_type__in: params?.mediaTypeIn,
      provider__in: params?.providerIn,
      country__in: params?.countryIn,
      region__in: params?.regionIn,
    },
  });
}

type QueryFnType = typeof getEconomicalValueChannelSourcesList;

interface UseGetEconomicalValueChannelSourcesListParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<EconomicalValueChannelSourceFilters>;
}

export function useGetEconomicalValueChannelSourcesList({
  config,
  params,
}: UseGetEconomicalValueChannelSourcesListParams = {}) {
  return useQuery({
    ...config,
    queryKey: economicalValueChannelSourcesQueryKeys.list(params),
    queryFn: () => getEconomicalValueChannelSourcesList(params),
  });
}
